export const format_date = (date: string): string => {
    if (!date) return date
    return date.split('-').reverse().join('.')
}
